export default {
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    permission: ['dashboard.accounts', 'Pull'],
    
  },
  {
    name: 'Submeter Resgate',
    url: '/emissao',
    icon: 'icon-calculator',
    condition: (dsrPaymentMethod, dealerId) => dsrPaymentMethod === 2,  // Custom condition
    permission: ['dashboard.accounts'],
  },
  {
    name: 'Pedidos de Resgate',
    url: '/pull',
    icon: 'icon-list',
    permission: ['Pull'],
    
  },
  {
    name: 'Histórico de Resgates',
    url: '/pull-history',
    icon: 'icon-list',
    permission: ['Pull'],
    
  },
  {
    name: "Ativação Hellmann's",
    url: '/coupons',
    icon: 'icon-user'
  },
  // {
  //   name: 'Perfil',
  //   url: '/perfil', // Rota perfil
  //   icon: 'icon-user'
  // },
  {
    name: 'Logout',
    url: '/logout', // Rota que cuidará do logout
    icon: 'icon-logout'
  },
  ]
};